export function getHslBgColor(userId: number) {
  return `hsl(${userId % 360} 100% var(--brightness-avatar-colorful-bg))`;
}
